import { useEffect } from 'react';
import ApplicationLogo from '../Components/ApplicationLogo';
import { Link } from '@inertiajs/react';

export default function Guest({ children, company }) {
    useEffect(() => {
        // Save original body styles
        const originalPaddingTop = document.body.style.paddingTop;
        const originalBackground = document.body.style.background;

        // Clean styles for login screen
        document.body.style.paddingTop = '0px';

        return () => {
            // Restore original body styles on unmount
            document.body.style.paddingTop = originalPaddingTop;
            document.body.style.background = originalBackground;
        };
    }, []);

    return (
        <div style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
            padding: '40px 15px',
        }}>
            <div style={{
                width: '100%',
                maxWidth: '480px',
                background: '#ffffff',
                borderRadius: '16px',
                boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
                border: '1px solid #edf2f7',
                padding: '45px 35px',
                display: 'flex',
                flexDirection: 'column',
            }}>
                <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '32px' }}>
                    <Link href="/login" style={{ textDecoration: 'none' }}>
                        <ApplicationLogo company={company} />
                    </Link>
                </div>
                <div style={{ width: '100%' }}>
                    {children}
                </div>
            </div>
        </div>
    );
}
